import request from '../utils/request'

export default {
  async lists(data) { // 获取商品列表
    const ret = await request('/v1/goodsHelp/lists', data, 'POST')
    return ret
  },

  async operate(data) { // 新增/编辑
    const ret = await request('/v1/goodsHelp/operate', data, 'POST')
    return ret
  },
  async status(data) { // 修改
    const ret = await request('/v1/goodsHelp/status', data, 'POST')
    return ret
  },

  async delete(data) { // 删除
    const ret = await request('/v1/goodsHelp/delete', data, 'POST')
    return ret
  }
}